import { Alert } from "@mui/material";
import WifiOffIcon from '@mui/icons-material/WifiOff';

import { OnlineStatus } from "../../Network/types";
import { useOnlineStatus } from "../../Network/useOnlineStatus";


interface OfflineNoticeProps {
    text?: string;
};

const OfflineNotice = (props: OfflineNoticeProps): JSX.Element =>  {

    const onlineStatus = useOnlineStatus();

    return (
        <>
        {onlineStatus === OnlineStatus.Offline && 
            <Alert icon={<WifiOffIcon/>} severity='warning'>You are currently offline. {props.text}</Alert>
        }
        </>
    );

};

export default OfflineNotice;